import { supportLabels } from "@/i18n";
import { CATEGORY_LABELS } from "@/types/support";
import { getLanguage, type Language } from "@/utils/languageUtils";

export function getSupportCategoryLabel(
  category: string,
  lang?: Language,
): string {
  if (!category) return "";

  const complaintTypes = supportLabels(lang).complaintTypes as
    | Record<string, { label?: string }>
    | undefined;
  const fromComplaint = complaintTypes?.[category]?.label;
  if (typeof fromComplaint === "string" && fromComplaint) {
    return fromComplaint;
  }

  const fromStatic = CATEGORY_LABELS[category as keyof typeof CATEGORY_LABELS];
  if (fromStatic) return fromStatic;

  return category;
}

export function getSupportCategoryLabelForCurrentLanguage(
  category: string,
): string {
  return getSupportCategoryLabel(category, getLanguage());
}

/** Resolve human-readable category for support notification payloads. */
export function resolveSupportNotificationCategoryLabel(
  data: Record<string, unknown>,
  lang?: Language,
): string {
  if (data.categoryLabel) {
    return String(data.categoryLabel);
  }

  const tag = Array.isArray(data.tags) ? data.tags[0] : undefined;
  if (typeof tag === "string" && tag) {
    const fromTag = getSupportCategoryLabel(tag, lang);
    if (fromTag !== tag) return fromTag;
  }

  if (typeof data.category === "string" && data.category) {
    const fromCategory = getSupportCategoryLabel(data.category, lang);
    if (fromCategory !== data.category) return fromCategory;
  }

  const title = String(data.title || "").trim();
  const prefixMatch = title.match(/^(?:Reklamation|Support):\s*(.+)$/i);
  if (prefixMatch?.[1]) {
    return getSupportCategoryLabel(prefixMatch[1].trim(), lang);
  }

  return title;
}
